import React from 'react';
import '../styles/NestedIframeExample.css';

const parentFrameSrc = `${process.env.PUBLIC_URL || ''}/iframes/nested-parent.html`;

const NestedIframeExample = () => {
  return (
    <div className="nested-iframe-example">
      <h2 className="nested-iframe-heading">Nested Iframes</h2>
      <p className="nested-iframe-description">
        Practice switching between the parent iframe and the nested child iframe.
      </p>

      <div className="nested-iframe-demo">
        <iframe
          id="parent-frame"
          name="parent-frame"
          title="Parent Frame"
          src={parentFrameSrc}
          className="nested-parent-frame"
        />
      </div>
    </div>
  );
};

export default NestedIframeExample;
